export * from "./common"
export * from "./ifDto";
export * from "./savePdf";
export * from "./startPdf";

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		position = position || 0;
		return this.substr(position, searchString.length) === searchString;
	};
}
if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        let len = (this == null) ? 0 : this.length;
        if (!len) return -1;

        for (let i = 0; i < len; i++) {
            if (predicate(this[i], i, this)) {
                return i;
			}
        }

        return -1;
    };
}